// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","container":"dLUazpZj","top":"M6U7IwL0","desc":"laBU0+QD","title":"Hkd9RaLy","link":"L20qDVSP"};